import Vue from 'vue';
import Vuex from 'vuex';
import { User, Cms, Wallet, Msg, Mall } from '../../index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    primaryColor: '#2979ff',
  },
  mutations: {
    updateState(state, payload) {
      const keys = Object.keys(payload);
      keys.forEach(key => {
        state[key] = payload[key];
      });
    },
  },
  actions: {},
  modules: {
    user: User.modules, // 用户模块相关状态
    cms: Cms.modules, // 文章模块相关状态
    wallet: Wallet.modules, // 钱包模块相关状态
    msg: Msg.modules, // 消息模块相关状态
    mall: Mall.modules, // 商城模块相关状态
  },
});
